// API Configuration
// In production, this will be set via environment variable REACT_APP_API_URL
// For Railway deployment, set this to your backend service URL

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
